import pegasus from '../../assets/scripts/global/01-pegasus';

export default class WideImageWithText {
    visible = false;
    lineCount = 2;

    constructor(lineCount) {
        this.lineCount = lineCount;
    }

    init() {
        
        pegasus.parallaxScroll(this.$refs.paralaxScrollElem)
            
    }

    resizeTextArea() {
        const textArea = this.$el.querySelector('.text-area');
        const textAreaWidth = this.getTextAreaWidth(textArea).width;

        console.log('textArea: ', textArea);

        if(window.innerWidth < 768) {
            textArea.style.width = '100%';
            return;
        }

        console.log(`(${textAreaWidth} / ${this.lineCount}) + 40 + 'px'`);

        textArea.style.width = (textAreaWidth / this.lineCount) + 40 + 'px';
    }

    getTextAreaWidth(element) {
        const newElem = element.cloneNode(true);
        newElem.style.display = "block";
        newElem.style.whiteSpace = "nowrap";
        newElem.style.width = "";
        document.body.appendChild(newElem);
        let rect = newElem.getBoundingClientRect();
        document.body.removeChild(newElem);
        return rect;
    }

}


document.addEventListener('alpine:init', () => {
    Alpine.data('wideImageWithText', (lineCount) => new WideImageWithText(lineCount));
});